/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { createBrowserHistory } from 'history';

// project imports
import { ACCESS_TOKEN, APP_TOKEN, getToken } from 'shared/settings/token';
import { logout } from 'shared/settings/auth';
import toast from 'shared/toast';
import { adminServiceUrl, buyerServiceUrl, paymentServiceUrl, sellerServiceUrl, membershipbaseurl } from 'shared/settings/apiconfig';

/* combines base url with endpoint and query params and returns complete url */
export function getSellerUrl(endPoint, params = null) {
    let apiUrl = sellerServiceUrl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}


export function getMembershipUrl(endPoint, params = null) {
    let apiUrl = membershipbaseurl + endPoint;

    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
    
}

/* returns http options based on params passed else returns default options */
export function getBuyerHeaders(auth = true, contentType = 'json', data = null) {
    const headers = {};
    let final = {};
    switch (contentType) {
        case 'json':
            headers['Content-Type'] = 'application/json';
            break;

        default:
    }

    if (auth) {
        headers['Authorization'] = `Bearer ${getToken(ACCESS_TOKEN)}`;
    }

    final = { headers: headers };

    if (data) {
        final['data'] = JSON.stringify(data);
    }

    return final;
}

/* http error handler(should be called in axios catch block) */
export function errorHandler(error) {
    toast.error(error.response.data.message || '');

    // logout user when the access token becomes invalid or expired
    // TODO: use ctbids http code once implemented instead of unauthorized message
    if (error.response.data.message === 'Unauthorized : Invalid or expired token') {
        logout(createBrowserHistory());
    }
}

/* combines base url with endpoint and query params and returns complete url */
export function getBuyersUrl(endPoint, params = null) {
    let apiUrl = buyerServiceUrl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

/* returns http options based on params passed else returns default options */
export function getAppHeaders(auth = false, contentType = 'json') {
    const headers = {};

    switch (contentType) {
        case 'json':
            headers['Content-Type'] = 'application/json';
            break;

        default:
            headers['Content-Type'] = '';
    }
    if (auth) {
        headers['Authorization'] = `Bearer ${getToken(APP_TOKEN)}`;
    }

    return { headers: headers };
}

/* combines base url with endpoint and query params and returns complete url */
export function getAdminUrl(endPoint, params = null) {
    let apiUrl = adminServiceUrl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

/* combines base url with endpoint and query params and returns complete url */
export function getPaymentUrl(endPoint, params = null) {
    let apiUrl = paymentServiceUrl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

/* returns http options based on params passed else returns default options */
export function getPaymentHeaders(token, auth = true, contentType = 'json') {
    const headers = {};

    switch (contentType) {
        case 'json':
            headers['Content-Type'] = 'application/json';
            break;

        default:
            headers['Content-Type'] = '';
    }
    if (auth) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return { headers: headers };
}